import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/components/ui/hover-card.js';
import { ReactNode, useRef, useState } from 'react';

interface TooltipProps {
  trigger: ReactNode;
  children: ReactNode;
  contentClassName?: string;
}

export const Tooltip = ({ trigger, children, contentClassName }: TooltipProps) => {
  const [open, setOpen] = useState(false);
  const triggerRef = useRef<HTMLAnchorElement>(null);

  return (
    <HoverCard open={open} onOpenChange={setOpen} openDelay={0}>
      <HoverCardTrigger
        ref={triggerRef}
        onClick={() => setOpen((prev) => !prev)}
        className="cursor-pointer group/tooltip"
      >
        {trigger}
      </HoverCardTrigger>
      <HoverCardContent
        className={contentClassName}
        onPointerDownOutside={(event) => {
          const target = event.detail.originalEvent.target as Node | null;
          if (target && triggerRef.current?.contains(target)) {
            event.preventDefault();
          }
        }}
      >
        {children}
      </HoverCardContent>
    </HoverCard>
  );
};
